import { useIntl } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';

export type FTUpgradeDrawerProps = {
	onButtonPress: () => void;
	onSecondaryActionOnButtonPress: () => void;
	testID: string;
};

export const FTUpgradeDrawer = ({ onButtonPress, onSecondaryActionOnButtonPress, testID }: FTUpgradeDrawerProps) => {
	const { $t } = useIntl();

	const fTUpgradeDrawerData = {
		buttonText: $t('wallet.receive.ftUpgradeDrawer.continueButton'),
		description: $t('wallet.receive.ftUpgradeDrawer.text'),
		isButtonOnRow: false,
		onButtonPress,
		onSecondaryActionOnButtonPress,
		secondaryActionButtonText: $t('wallet.receive.ftUpgradeDrawer.cancelButton'),
		testID: testID,
		title: $t('wallet.receive.ftUpgradeDrawer.title')
	};

	return <GenericDrawer {...fTUpgradeDrawerData} />;
};
